var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M7.238,2A5.243,5.243,0,0,0,2,7.238v9.525A5.244,5.244,0,0,0,7.238,22h9.525a5.183,5.183,0,0,0,3.327-1.227l.062-.013a.2.2,0,0,0-.01-.029A5.2,5.2,0,0,0,22,16.762V7.238A5.243,5.243,0,0,0,16.762,2Zm0,1.667h9.525a3.575,3.575,0,0,1,3.571,3.571v9.525A3.523,3.523,0,0,1,19.52,19a8.4,8.4,0,0,0-7.389-4.779,4.142,4.142,0,1,0-.277,0,8.3,8.3,0,0,0-7.393,4.753,3.518,3.518,0,0,1-.794-2.213V7.238A3.574,3.574,0,0,1,7.238,3.667ZM12,7.6a2.487,2.487,0,1,1-2.484,2.487A2.489,2.489,0,0,1,12,7.6Zm-.013,8.278a6.742,6.742,0,0,1,6.195,4.157,3.544,3.544,0,0,1-1.419.3H7.238A3.53,3.53,0,0,1,5.8,20.027,6.657,6.657,0,0,1,11.987,15.877Z",
    transform: "translate(-2 -2)",
    fill: "#1891e5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a809711c.svg";
export { ForwardRef as ReactComponent };